import React from "react";

/**
 * Pneupro brand mark — uses the official whirlpool logo image with a pulsating glow.
 */
export const BrandMark = ({ className = "h-12 w-12", title = "Pneupro", glow = false }) => {
  return (
    <img
      src="/pneupro-logo.png"
      alt={title}
      className={`object-contain ${glow ? "logo-glow" : ""} ${className}`}
      draggable={false}
    />
  );
};

export default BrandMark;
